import { Button } from "@mui/material";
import FilterAltOutlinedIcon from "@mui/icons-material/FilterAltOutlined";
import { FC } from "react";

interface AutomationResourceFilterSourceButtonProps {
  openDialog: () => void;
}

export const AutomationResourceFilterSourceButton: FC<
  AutomationResourceFilterSourceButtonProps
> = ({ openDialog }) => {
  return (
    <Button
      variant="text"
      onClick={openDialog}
      size="small"
      startIcon={<FilterAltOutlinedIcon sx={{ fontSize: "16px !important" }} />}
      sx={{
        py: 0,
        "& .MuiButton-startIcon": {
          marginRight: "4px",
        },
      }}
    >
      Edit Filters
    </Button>
  );
};
